import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../components/Title";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import { DataGrid } from '@material-ui/data-grid';
import Message from "../tools/Message";
import ConfirmationDialog from "../tools/ConfirmationDialog";
import moment from "moment";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import Spacer from "../../components/Spacer";
import { useNavigate } from 'react-router-dom';
import MettingService from "../../services/MettingService";
import ValidateMeetingDialog from "../tools/ValidateMettingDialog";
import { hasPrivilege } from "../../utils/privilege";
import { useContext } from "react";
import { userDetailContext } from "../../App";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function MettingApprovedTable(props) {
  const contextData = useContext(userDetailContext);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const classes = useStyles();
  const [isid, setIsid] = useState(0);
  const [comment, setComment] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'voulez vous supprimer?',
  });
  const [confirmationMetting, setConfirmationMetting] = React.useState({
    openDialogMetting: false,
    messageDialogMetting: 'Vous approuvez cette réunion?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const { openDialogMetting, messageDialogMetting } = confirmationMetting;
  const [message, setMessage] = React.useState({
    openMessage: false,
    color: 'green',
    messageInfo: '',
  });
  const { openMessage, color, messageInfo } = message;

  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

    useEffect(() => {
        setOpenLoadingSimpleBackdrop(true);
        MettingService.getMettingRefused().then((result) => {
        if (result && result.data) {
            setRows(result.data.map((row) => ({ ...row, id: row.id_meeting })));
            setOpenLoadingSimpleBackdrop(false);
        }
        else{
            setOpenLoadingSimpleBackdrop(false);
        }
        });
    }, []);

  const handleEdit = (id) => (ev) => {
    navigate("/Logistic/meeting_management/add/" + id);
  };

  const handleDelete = (id) => (ev) => {
    setIsid(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: 'voulez vous supprimer?' });
  };

  const handleApproved = (id) => (ev) => {
    setIsid(id);
    setConfirmationMetting({ ...confirmationMetting, openDialogMetting: true, messageDialogMetting: 'Vous confirmez cette réunion?' });
  }
  
  function loadTable() {
    MettingService.getMetting().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.id_meeting })));
      }
    });
  }

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
  }

  function closeDialogMetting() {
    setConfirmationMetting({ ...confirmationMetting, openDialogMetting: false, messageDialogMetting: 'voulez vous supprimer?' });
  }

  function confirmDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
    MettingService.deleteMettingById(isid).then((result) => {
      if (result.status==true) {
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        loadTable();
      } else {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
      }).catch((err) => {
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'Erreur'.isid });
    });
  }

  function confirmDialogApproved(comment) {
    setConfirmationMetting({ ...confirmationDialog, openDialogMetting: false, messageDialogMetting: 'Vous confirmez cette réunion?' });
    MettingService.ApprovedMettingByIdMetting(comment,isid).then((result) => {
      if (result.status==true) {
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        loadTable();
      } else {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
      }).catch((err) => {
        console.log(err);
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'Erreur'.isid });
    });
  }

  function handleRefused(comment) {
    setConfirmationMetting({ ...confirmationMetting, openDialogMetting: false, messageDialogMetting: 'Vous confirmez cette réunion?' });
    MettingService.RefusedMettingByIdMetting(comment,isid).then((result) => {
      if (result.status==true) {
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        loadTable();
      } else {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
      }).catch((err) => {
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'Erreur'.isid });
    });
  }


  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, openMessage: false });
  }

  const columns = [
    {
      field: 'date_meeting',
      headerName: 'Date',
      width: 150,
      valueFormatter: (params) => {
        return `${moment(params.row.date_meeting).format('DD/MM/YYYY')}`;
      },
    },
    { 
      field: 'time_meeting_start',
      headerName: 'Début',
      width: 150,
      valueFormatter: (params) => {
        return `${moment(params.row.time_meeting_start, 'HH:mm:ss').format('HH:mm')}`;
      },
    },
    { 
      field: 'time_meeting_end',
      headerName: 'Fin',
      width: 150,
      valueFormatter: (params) => {
        return `${moment(params.row.time_meeting_end, 'HH:mm:ss').format('HH:mm')}`;
      },
    },
    { 
      field: 'salle',
      headerName: 'Porte',
      width: 150,
    },
    // { 
    //   field: 'user_meeting',
    //   headerName: 'Utilisateur',
    //   width: 300,
    // },
    { 
        field: 'object_meeting',
        headerName: 'Objet',
        width: 180,
    },
    
    { 
      field: 'comment',
      headerName: 'Commentaire',
      width: 200,
    },
  ];
  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <ValidateMeetingDialog comment={comment} openDialogMetting={openDialogMetting} messageDialogMetting={messageDialogMetting} closeDialogMetting={closeDialogMetting} confirmDialogApproved={confirmDialogApproved} handleRefused={handleRefused}/>
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      {/* <Title>Réunions refusées</Title>
      <Spacer y={2} /> */}
      <div style={{ height: "85vh", width: '100%' }} className={classes.root} >
      
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={7}
          rowsPerPageOptions={[7]}
          disableSelectionOnClick
        />
      </div>
    </React.Fragment>
  );
}
